import { createSlice } from "@reduxjs/toolkit";
import { getClaimsHistory } from "../../reducer/claimsHistory/claimsHistoryReducer";

const initialState = {
  data: {
    claims: [],
    pagination: {},
  },
  isLoading: false,
  error: null,
};

const claimsHistorySlice = createSlice({
  name: "claimsHistory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClaimsHistory.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getClaimsHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || {};
      })
      .addCase(getClaimsHistory.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default claimsHistorySlice.reducer;
